import useAccount from '@elementary/common-ui/hooks/useAccount';
import { useAuth } from '@frontegg/react';

const useSupportChat = () => {
  const { user } = useAuth();
  const { data: account } = useAccount();

  const init = () => {
    if (user && account) {
      window.pylon = {
        chat_settings: {
          app_id: 'f471c2b3-7f86-42b3-8d52-58acebea9879',
          email: user.email,
          name: user.name,
        },
      };
    }
  };

  const show = () => window.Pylon('show');
  const hide = () => window.Pylon('hide');

  return { init, show, hide };
};

export default useSupportChat;
